import type { Profile, Submission } from '../types'

export default function SubmissionStatus({students,submissions}:{students:Profile[];submissions:Submission[]}) {
  const ids = new Set(submissions.filter(s=>s.files.length>0).map(s=>s.owner.id))
  const missing = students.filter(s=>!ids.has(s.id))
  const submitted = students.filter(s=>ids.has(s.id))
  return <details className="submission-status"><summary>제출 {submitted.length} / {students.length}명 · 미제출 {missing.length}명 — 명단 보기</summary>
    <h4>아직 안 낸 학생 ({missing.length}명)</h4><p>{missing.map(s=>s.displayName).join(' · ') || '모두 제출했어요!'}</p>
    <h4>제출한 학생 ({submitted.length}명)</h4><p>{submitted.map(s=>s.displayName).join(' · ') || '아직 없어요.'}</p>
  </details>
}
